import { render, staticRenderFns } from "./TkPage.vue?vue&type=template&id=5d809ba6&scoped=true&"
import script from "./TkPage.vue?vue&type=script&lang=js&"
export * from "./TkPage.vue?vue&type=script&lang=js&"
import style0 from "./TkPage.vue?vue&type=style&index=0&id=5d809ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d809ba6",
  null
  
)

export default component.exports